<form>
  <h1 class="mb-2"><mdb-icon fas icon="bell"></mdb-icon> Notificaciones</h1>

  <!-- Heading -->
  <div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
      <p class="mb-0">
        <span class="grey-text">Notificaciones</span>
        <span> /</span>
        <span>Todas</span>
      </p>
    </div>
  </div>
  <!-- Heading -->

  <!-- Cabecera de botones -->
  <div class="card mb-2 wow">
    <div class="card-body d-sm-flex p-1 justify-content-between">
      <div class="md-form d-sm-flex justify-content-start no-margin">
        <input
          type="text"
          id="buscar"
          class="form-control"
          placeholder="Buscar"
          required
          #buscar
        />
        <label for="vecodigo">Buscar</label>
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Listado -->
  <div class="card mb-2 wow">
    <div class="card-body d-sm-flex p-1 justify-content-end">
      <div class="table-responsive">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Acción</th>
              <th scope="col">Realizado por</th>
              <th scope="col">Fecha</th>
              <th scope="col">Estado</th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="7">Inventario</td>
            </tr>
            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" default="true">Pendiente</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>

            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>

            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" danger="true">Denegado</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="7">Cuentras Corrientes</td>
            </tr>
            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" default="true">Pendiente</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>

            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>

            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" danger="true">Denegado</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>

            <tr>
              <td colspan="7">Ventas</td>
            </tr>
            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" default="true">Pendiente</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>

            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>

            <tr>
              <td>001</td>
              <td>Ajsute de inventario</td>
              <td>
                Juanito Perez
              </td>
              <td>10-10-2019</td>
              <td>
                <mdb-badge pill="true" danger="true">Denegado</mdb-badge>
              </td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="success"
                  mdbWavesEffect
                  class="btn-actions-sm"
                  (click)="editarAtributos.show()"
                >
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="primary"
                  mdbWavesEffect
                  class="btn-actions-sm"
                >
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- MODAL Agregar rol -->
    <div
      mdbModal
      #edagregarAtributos="mdb-modal"
      class="modal fade"
      id="basicExample"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      [config]="{ backdrop: true, ignoreBackdropClick: true }"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title w-100 text-left" id="myModalLabel">
              Agregar
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              (click)="edagregarAtributos.hide()"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos de atributo
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input
                    value=""
                    type="text"
                    id="operacion"
                    class="form-control"
                    placeholder="Operación"
                    required
                    #operacion
                  />
                  <label for="operacion">Atributo</label>
                </div>
                <div class="md-form">
                  <input
                    value=""
                    type="text"
                    id="descripcion"
                    class="form-control"
                    placeholder="Descripción"
                    required
                    #descripcion
                  />
                  <label for="descripcion">Descripción</label>
                </div>

                <div>
                  <!-- Material inline 1 -->
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="materialInline1"
                      name="inlineMaterialRadiosExample"
                      mdbInput
                    />
                    <label class="form-check-label" for="materialInline1"
                      >Con aprobación</label
                    >
                  </div>

                  <!-- Material inline 2 -->
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="materialInline2"
                      name="inlineMaterialRadiosExample"
                      mdbInput
                    />
                    <label class="form-check-label" for="materialInline2"
                      >Notificatoria</label
                    >
                  </div>

                  <!-- Material inline 3 -->
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="materialInline3"
                      name="inlineMaterialRadiosExample"
                      mdbInput
                    />
                    <label class="form-check-label" for="materialInline3"
                      >Sin notificación</label
                    >
                  </div>
                </div>

                <div class="md-form">
                  <mdb-select label="Rol" placeholder="Rol"></mdb-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-default waves-light"
              data-dismiss="modal"
              (click)="edagregarAtributos.hide()"
              mdbWavesEffect
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-secondary waves-light"
              mdbWavesEffect
              (click)="edagregarAtributos.hide()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL Editar rol -->
  <div
    mdbModal
    #editarAtributos="mdb-modal"
    class="modal fade"
    id="basicExample"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Detalle del proceso
          </h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="editarAtributos.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Ajuste de Inventario
              </h5>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="table-responsive">
                <table
                  class="table table-striped table-hover table-sm align-middle"
                >
                  <thead class="grey lighten-2">
                    <tr>
                      <th>Producto</th>
                      <th>Ajuste</th>
                      <th>UMP. Principal</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Nombre producto</td>
                      <td>10</td>
                      <td>22</td>
                      <td>32</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="editarAtributos.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            type="button"
            class="btn btn-success waves-light"
            color="success"
            mdbWavesEffect
            (click)="editarAtributos.hide()"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
